import { TrainingSessionNodeSelectedEventArgs } from './../training-tree/training-tree.component';
import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material';
import { HierarchyNodeSelectedEventArgs } from '../hierarchy-tree/hierarchy-tree.component';
import { EmitterService } from '../../service/EmitterService';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import {UserNode} from '../../model/user-node';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.css']
})
export class TrainingComponent implements OnInit {

   agentName = null;
   teamName = null;
   siteName = null;
   agents = [];
   title: any = null;
  public valueDate: any =  new FormControl((new Date()).toISOString());
  public minDate: any = new Date(2000, 0, 1);
  public maxDate: any = new Date();
  public _isNow = false;
  constructor(private eventEmitter: EmitterService, private route: ActivatedRoute) { }

  ngOnInit() {
    // console.log(this.GetQuerySearch(1));
    this._isNow = this.isNow(this.valueDate.value)
    this.eventEmitter.getChangeEmitter().subscribe((eventArgs: any) => {
      this.agents = eventArgs.members.map((e,i ) => {
        var o = e;
        o['session'] = eventArgs.teamName;
        return o
      })
      this.title = [eventArgs.siteName, eventArgs.teamName, eventArgs.agentName];// console.log(this.title);
      this.title = this.title.filter(d => d !== '' || d !== null).join(' > ');
    });
  }

  onTrainingSessionTreeNodeActivated(eventArgs: HierarchyNodeSelectedEventArgs) {
    this.agents = eventArgs.members.map(e => e['session'] = eventArgs.teamName)
    // console.log('>>>>', this.agents)
    this.title = [eventArgs.siteName, eventArgs.teamName, eventArgs.agentName];
    this.title = this.title.filter(d => (d !== null || d !== ''));
    this.title = this.title.join(' > ');
  }

  public ChangeDateGlobal(event: MatDatepickerInputEvent<Date>) {
    this.eventEmitter.emithDate(event.value);
    this._isNow = this.isNow(this.valueDate.value)
  }

  public GetQuerySearch(type?, data?) {
    if (type === 1) { return data; }
    this.route.queryParams.subscribe( param => this.GetQuerySearch(0, param));
  }
  Goto(type) {
    let i = 0;
    switch (type) {
      case 'next': i = i + 1 ;break;
      case 'prev': i = i - 1 ;break;
    }
    const d = new Date(this.valueDate.value);
    d.setDate(d.getDate() + i);
    this.valueDate = new FormControl(d.toISOString())
    this._isNow = this.isNow(this.valueDate.value)
    this.eventEmitter.emithDate(this.valueDate.value);
  }
  isNow(d) {
    const d1 = moment(d, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const d2 = moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD');
    return  moment(d1).isSame(d2);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/training/training.component.ts